import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';

const getSuggestedDays = (kitchen) => {
  if (!kitchen?.RateEntries || kitchen.RateEntries.length === 0) {
    return "Check calendar for availability";
  }

  const recurringDays = kitchen.RateEntries
    .filter(entry => entry.recurring && entry.dayOfWeek)
    .map(entry => entry.dayOfWeek);
  
  const uniqueDays = [...new Set(recurringDays)];

  if (uniqueDays.length > 0) {
    const dayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    uniqueDays.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
    return `Often available: ${uniqueDays.join(', ')}`;
  }

  return "Check calendar for specific dates";
};

const BookNowBar = ({ kitchen, totalAmount, checkinDate, checkoutDate, isCheckingAvailability, onBookNowClick, show }) => {
  if (!show) return null;

  const hourlyRate = kitchen?.HourlyRate;
  
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: '70px', md: '0' },
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(8px)',
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
        padding: { xs: '12px 16px', md: '16px 24px' },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.3s ease-in-out',
        transform: show ? 'translateY(0)' : 'translateY(100%)',
      }}
    >
      <Box>
        <Typography variant="h6" component="div" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {totalAmount > 0 
            ? `$${totalAmount.toFixed(2)} total`
            : (hourlyRate ? `$${hourlyRate} / hour` : 'Check availability')}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {checkinDate && checkoutDate
            ? `${moment(checkinDate).format('MMM D')} - ${moment(checkoutDate).format('MMM D')}`
            : getSuggestedDays(kitchen)}
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={onBookNowClick}
        disabled={isCheckingAvailability}
        sx={{
          borderRadius: '12px',
          px: { xs: 3, md: 4 },
          py: { xs: 1, md: 1.5 },
          fontWeight: 600,
          boxShadow: '0 4px 15px rgba(230, 57, 70, 0.4)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(230, 57, 70, 0.5)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        {isCheckingAvailability ? 'Checking...' : 'Book Now'}
      </Button>
    </Box>
  );
};

export default BookNowBar; 